import { moduleLogger } from "../util";
import { fetchRetry } from "./FetchRetry";
import { sendCustomError } from "@otto-ec/global-resources/apm";

const log = moduleLogger.scope("activation-client");

export class ActivationClient {
	async activateViaUrl(activationUrl: string, errorLoggingPayload: object): Promise<boolean> {
		/*                           */
		if (activationUrl === "https:/*                                                                                  */
			return new Promise((resolve) => setTimeout(() => resolve(true), 1000));
		}

		const fetchOptions: RequestInit = {
			method: "POST",
			headers: { "X-Requested-With": "XMLHttpRequest" },
		};

		log.info(`[benefit-detailview] Call ${activationUrl} to activate benefit using following options: ${JSON.stringify(fetchOptions)}`);

		try {
			const response = await fetchRetry(activationUrl, fetchOptions, {
				limit: 2,
				delay: 500,
				timeout: 1000,
			});

			if (!response.ok) {
				sendCustomError("ft9-benefit-detailview-activation-failed", {
					...errorLoggingPayload,
					failing_reason: "Response is not OK",
					status_code: response.status,
					response_type: response.type,
					response_ok: response.ok,
					response_headers: JSON.stringify(response.headers),
				});
			}

			return response.status === 200;
		} catch (e: unknown) {
			if (e instanceof Error) {
				log.error(`[benefit-detailview] Exception calling activation ${activationUrl} reason: ${e.message}`);
				sendCustomError("ft9-benefit-detailview-activation-failed", {
					...errorLoggingPayload,
					failing_reason: "error",
					error_message: e.message,
					error_name: e.name,
				});
			} else if (typeof e === "string") {
				log.error(`[benefit-detailview] Exception calling activation ${activationUrl} reason: ${e}`);
				sendCustomError("ft9-benefit-detailview-activation-failed", {
					...errorLoggingPayload,
					failing_reason: "error-message",
					error_message: e,
				});
			}

			return false;
		}
	}
}
